// A box like the cards: the card surface in dark mode, a 1px outline in light,
// square in both, with the accent rule down the left.
.synopsis {
	margin: var(--mantine-spacing-md) 0;
	border: none;
	border-left: 3px solid var(--docs-accent);
	border-radius: 0;
	background: var(--docs-card);
	overflow: hidden;

	@include light {
		border: 1px solid var(--surreal-border-default);
		border-left: 3px solid var(--docs-accent);
	}
}

.synopsis-caption {
	padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);
	// The panel divider in dark mode, where the page line would vanish on the
	// card surface; the page line in light mode.
	border-bottom: 1px solid var(--docs-panel-line, var(--surreal-border-default));
	font-size: calc(0.7rem + 1px);
	font-weight: 600;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: var(--mantine-color-dimmed);

	@include light {
		color: var(--mantine-color-obsidian-5);
	}
}

.synopsis-body {
	margin: 0;
	padding: var(--mantine-spacing-md);
	font-family: var(--mantine-font-family-monospace);
	font-size: 0.9em;
	font-variant-ligatures: none;
	line-height: 1.7;
	tab-size: 4;

	// Wrap rather than clip: a usage line ends in the arguments that matter most, and
	// a horizontally scrolling block is unreachable without a pointer.
	white-space: pre-wrap;
	overflow-wrap: break-word;
	color: var(--mantine-color-bright);

	code {
		font-family: inherit;
		font-size: inherit;
		padding: 0;
		border: 0;
		background: none;
		color: inherit;
	}

	// Fallback path: markdown children arrive wrapped in paragraphs.
	p {
		margin: 0;
		white-space: pre-wrap;
	}
}

.synopsis-line {
	display: block;
	padding-left: 2ch;
	text-indent: -2ch;

	// Keep a blank line in the source occupying a line box.
	min-height: 1.7em;
}
